import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API } from '../../api';

@Injectable({
    providedIn: 'root'
})
export class ClientService {
    private url: string = API + '/client';

    constructor(private http: HttpClient) { }

    getClients(): Observable<any> {
        return this.http.get(this.url);
    }

    allClients(): Observable<any> {
        return this.http.get(`${this.url}/all`);
    }

    getClient(id: number): Observable<any> {
        return this.http.get(`${this.url}/${id}`);
    }

    createClient(client: any): Observable<any> {
        return this.http.post(this.url, client);
    }

    updateClient(id: number, client: any): Observable<any> {
        return this.http.put(`${this.url}/${id}`, client);
    }
}
